import Vue from "vue";
import Vuex from "vuex";

import actions from "./store_modules/Actions";
import mutations from "./store_modules/Mutations";
import getters from "./store_modules/Getters";

Vue.use(Vuex);

const nowDate = new Date();

export default new Vuex.Store({
  state: {
    scrollSpeed: 500,
    url: {
      endpoint_host: HOST,
      file_host: fileHOST,
      endpoint_base: HOST + "/gateway",
      endpoint: HOST + "/gateway/?appId=000000003z7H&binding=json&",
    },
    language: undefined,
    translation: undefined,
    musicPlayList: [],
    static_content: [],
    homepageList: [],
    sliderList: [],
    announcements: [],
    sezenden_list: [],
    press_list: [],
    press_extra_images: [],
    allwork_home: [],
    albums_list: [],
    album_tracklist: [],
    album_images: [],
    select_options: undefined,
    search_song_list: [],
    products_list: [],
    videos_list: [],
    photos_list: [],
    updates: [],
    press_dates_list: {
      photo_novels: [{ from: 1980, to: nowDate.getFullYear() }],
      print_publications: [{ from: 1980, to: nowDate.getFullYear() }],
      press_clippings: [
        { from: 2020, to: undefined },
        {
          from: 2010,
          to: 2019,
        },
        {
          from: 2005,
          to: 2009,
        },
        {
          from: 2000,
          to: 2004,
        },
        {
          from: 1990,
          to: 1999,
        },
        {
          from: 1980,
          to: 1989,
        },
        {
          from: 1970,
          to: 1979,
        },
      ],
      foreign_press_clippings: [
        { from: 2020, to: undefined },
        {
          from: 2010,
          to: 2019,
        },
        {
          from: 2005,
          to: 2009,
        },
        {
          from: 2000,
          to: 2004,
        },
      ],
    },
  },
  getters,
  mutations,
  actions,
});
